import {Component, Input} from '@angular/core';

declare var google: any;

@Component({
  selector: 'app-small-map',
  templateUrl: './small-map.html',
})
export class SmallMapComponent {
  @Input() location: {};

  factor = 0.25;
  selected = {
    url: './assets/img/map/selected.png', // url
    scaledSize: new google.maps.Size(89 * this.factor, 100 * this.factor), // scaled size
  };

  constructor() {
  }

  map: any;

  ngOnInit() {
    this.initMap(location);
    this.addMarker();
  }

  initMap(center) {
    this.map = new google.maps.Map(document.getElementById('map'), {
      center: this.location,
      zoom: 14,
      disableDefaultUI: true
    });
  }

  //adds marker
  addMarker() {
    new google.maps.Marker({
      position: this.location,
      map: this.map,
      icon: this.selected
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/small-map/small-map.ts